import React, { useState, useEffect } from "react";
import Table from "../../../../core/pagination/datatable";
import { Link } from "react-router-dom";
import { Spin, Drawer, Modal, Input } from "antd";
import { Edit } from "feather-icons-react/build/IconComponents";
import { Trash } from "react-feather";
import { getApiBaseUrl, LOGIN, ADD_ACTIVITY } from "../../Config/Config";
import Swal from "sweetalert2";

const Areas = () => {
  const columns = [
    {
      title: "Areas Name",
      dataIndex: "Name",
    },
    {
      title: "Description",
      dataIndex: "Description",
    },
    {
      title: "Code",
      dataIndex: "Code",
    },
    {
      title: "Actions",
      align: "center",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link className="me-2 p-2" onClick={() => handleEditClick(record)}>
              <Edit className="feather-edit" />
            </Link>
            <Link className="me-2 p-2" onClick={() => handleDeleteClick(record)}>
              <Trash className="feather-trash" />
            </Link>
          </div>
        </div>
      ),
    },
  ];

  const [areas, setAreas] = useState([]);
  const [loading, setLoading] = useState(false);

  const [addForm, setAddForm] = useState({
    Name: "",
    Code: "",
    Description: "",
  });
  const [addDrawerOpen, setAddDrawerOpen] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [askPasswordAdd, setAskPasswordAdd] = useState(false);
  const [passwordAdd, setPasswordAdd] = useState("");
  const [showPasswordAdd, setShowPasswordAdd] = useState(false);
  const [errorAdd, setErrorAdd] = useState("");

  const [editForm, setEditForm] = useState({
    Id: null,
    Name: "",
    Code: "",
    Description: "",
  });
  const [editDrawerOpen, setEditDrawerOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [askPasswordEdit, setAskPasswordEdit] = useState(false);
  const [passwordEdit, setPasswordEdit] = useState("");
  const [showPasswordEdit, setShowPasswordEdit] = useState(false);
  const [errorEdit, setErrorEdit] = useState("");


  const [reauthVisible, setReauthVisible] = useState(false);
  const [passwordDelete, setPasswordDelete] = useState("");
  const [passwordErrorDelete, setPasswordErrorDelete] = useState("");
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [recordToDelete, setRecordToDelete] = useState(null);

  const user = JSON.parse(sessionStorage.getItem("user") || "{}");

  const fetchAreas = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${getApiBaseUrl()}/Areas/getareas`);
      const json = await res.json();

      if (json?.Status) {
        setAreas(json.ResultData || []);
      } else {
        console.error("Failed to fetch areas:", json?.Message);
      }
    } catch (err) {
      console.error("Error fetching areas:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAreas();
  }, []);


  const logActivity = async (isSuccess, notes) => {
    try {
      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ActivityType: 1,
          PerformedBy: user?.UserID,
          PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
          Notes: notes,
          Location: "Areas",
          IsSucces: isSuccess ? 1 : 0,
        }),
      });
    } catch (err) {
      console.error("Failed to log activity:", err);
    }
  };


  const handleAddSubmit = () => {
    if (!addForm.Name.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Area Name is required.",
      });
      return;
    }

    setAskPasswordAdd(true);
    setErrorAdd("");
  };

  const handleAuthAdd = async () => {
    if (!passwordAdd) {
      setErrorAdd("Please enter your password.");
      return;
    }

    setAddLoading(true);
    setErrorAdd("");

    try {
      const authPayload = {
        username: user?.UserName,
        password: passwordAdd,
      };
      const authRes = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(authPayload),
      });
      const authData = await authRes.json();

      if (authData.status) {
        setAskPasswordAdd(false);
        setPasswordAdd("");
        await performAdd();
      } else {
        setErrorAdd(authData.Message || "Invalid credentials.");
      }
    } catch (err) {
      setErrorAdd("Unable to authenticate.");
    } finally {
      setAddLoading(false);
       fetchAreas();
    }
  };

  const performAdd = async () => {
    const payload = {
      Name: addForm.Name.trim(),
      Code: addForm.Code.trim(),
      Description: addForm.Description.trim(),
      CreatedBy: user.UserID,
    };

    try {
      const res = await fetch(`${getApiBaseUrl()}/Areas/addareas`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const json = await res.json();

      if (json?.Status) {
        await logActivity(true, `Area "${payload.Name}" added successfully`);
        Swal.fire("Success", "Area added successfully!", "success").then(() => {
          setAddDrawerOpen(false);
          setAddForm({ Name: "", Code: "", Description: "" });
          fetchAreas();
        });
      } else {
        await logActivity(false, `Failed to add Area "${payload.Name}"`);
        Swal.fire("Failed", json?.Message || "Something went wrong!", "error");
      }
    } catch (error) {
      await logActivity(false, `Error adding Area "${payload.Name}"`);
      Swal.fire("Failed", "Failed to connect to server.", "error");
    }
  };

  const handleEditClick = (record) => {
    setEditForm({
      Id: record.Id,
      Name: record.Name,
      Code: record.Code,
      Description: record.Description,
    });
    setEditDrawerOpen(true);
  };

  const handleEditSubmit = () => {
    if (!editForm.Name.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Area Name is required.",
      });
      return;
    }

    setAskPasswordEdit(true);
    setErrorEdit("");
  };

  const handleAuthEdit = async () => {
    if (!passwordEdit) {
      setErrorEdit("Please enter your password.");
      return;
    }

    setSaving(true);
    setErrorEdit("");

    try {
      const authPayload = {
        username: user?.UserName,
        password: passwordEdit,
      };
      const authRes = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(authPayload),
      });
      const authData = await authRes.json();

      if (authData.status) {
        setAskPasswordEdit(false);
        setPasswordEdit("");
        await performEdit();
      } else {
        setErrorEdit(authData.Message || "Invalid credentials.");
      }
    } catch (err) {
      setErrorEdit("Unable to authenticate.");
    } finally {
      setSaving(false);
    }
  };

  const performEdit = async () => {
    const payload = {
      Id: editForm.Id,
      Name: editForm.Name.trim(),
      Code: editForm.Code.trim(),
      Description: editForm.Description.trim(),
      UpdatedBy: user.UserID,
    };

    try {
      const res = await fetch(`${getApiBaseUrl()}/Areas/updateareas`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const json = await res.json();

      if (json?.Status) {
        await logActivity(true, `Area "${payload.Name}" updated successfully`);
        Swal.fire("Success", "Area updated successfully!", "success").then(() => {
          setEditDrawerOpen(false);
          setEditForm({ Id: null, Name: "", Code: "", Description: "" });
          fetchAreas();
        });
      } else {
        await logActivity(false, `Failed to update Area "${payload.Name}"`);
        Swal.fire("Failed", json?.Message || "Something went wrong!", "error");
      }
    } catch (error) {
      await logActivity(false, `Error updating Area "${payload.Name}"`);
      Swal.fire("Failed", "Failed to connect to server.", "error");
    }
  };

  const handleDeleteClick = (record) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this Area?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setRecordToDelete(record);
        setPasswordDelete("");
        setPasswordErrorDelete("");
        setReauthVisible(true);
      }
    });
  };

  const handleDeleteConfirm = async () => {
    if (!passwordDelete.trim()) {
      setPasswordErrorDelete("Please enter your password");
      return;
    }

    setDeleteLoading(true);
    setPasswordErrorDelete("");

    try {
      const authRes = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: user?.UserName,
          password: passwordDelete,
        }),
      });
      const authData = await authRes.json();

      if (authData.status) {
        setReauthVisible(false);
        setPasswordDelete("");
        await performDelete(recordToDelete);
      } else {
        setPasswordErrorDelete(authData.Message || "Invalid password");
      }
    } catch (err) {
      setPasswordErrorDelete("Authentication failed.");
    } finally {
      setDeleteLoading(false);
    }
  };

  const performDelete = async (record) => {
    const payload = {
      Id: record.Id,
      UpdatedBy: user.UserID,
    };

    try {
      const res = await fetch(`${getApiBaseUrl()}/Areas/deleteareas`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const json = await res.json();

      if (json?.Status) {
        await logActivity(true, `Area "${record.Name}" deleted successfully`);
        Swal.fire("Success", "Area deleted successfully!", "success").then(() => {
          fetchAreas();
        });
      } else {
        await logActivity(false, `Failed to delete Area "${record.Name}"`);
        Swal.fire("Failed", json?.Message || "Something went wrong!", "error");
      }
    } catch (error) {
      await logActivity(false, `Error deleting Area "${record.Name}"`);
      Swal.fire("Failed", "Failed to connect to server.", "error");
    }
  };

  return (
    <>
      {(saving || addLoading || deleteLoading) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Areas{" "}
                  </h4>
                </ol>
              </nav>
              <h6>Manage Areas</h6>
            </div>
            <div className="page-btn">
              <Link
                onClick={() => setAddDrawerOpen(true)}
                className="btn btn-success btn-sm"
              >
                <i className="ti ti-circle-plus fs-4"></i>
              </Link>
            </div>
          </div>
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
              <div className="search-set mt-4"></div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : areas?.length > 0 ? (
                  <Table columns={columns} dataSource={areas} rowKey="Id" />
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
        </div>

        <Drawer
          title="Add Area"
          placement="right"
          width={420}
          closable={false}
          open={addDrawerOpen}
          onClose={() => {
            setAddDrawerOpen(false);
            setAddForm({ Name: "", Code: "", Description: "" });
            setAskPasswordAdd(false);
            setPasswordAdd("");
            setErrorAdd("");
          }}
          extra={
            <div>
              <button
                type="button"
                className="btn btn-sm btn-outline-success me-2"
                title="Save"
                onClick={handleAddSubmit}
                disabled={addLoading}
              >
                <i className="fa fa-check fs-4"></i>
              </button>
              <button
                type="button"
                className="btn-close text-reset"
                onClick={() => {
                  setAddDrawerOpen(false);
                  setAddForm({ Name: "", Code: "", Description: "" });
                  setAskPasswordAdd(false);
                  setPasswordAdd("");
                  setErrorAdd("");
                }}
              ></button>
            </div>
          }
        >
          <div className="mb-3">
            <label className="form-label">
              Area Name <span className="text-danger ms-1">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="Name"
              placeholder="Enter Area Name"
              value={addForm.Name}
              onChange={(e) =>
                setAddForm((prev) => ({ ...prev, Name: e.target.value }))
              }
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Code</label>
            <input
              type="text"
              className="form-control"
              name="Code"
              placeholder="Enter Code"
              value={addForm.Code}
              onChange={(e) =>
                setAddForm((prev) => ({ ...prev, Code: e.target.value }))
              }
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Description</label>
            <textarea
              className="form-control"
              name="Description"
              placeholder="Enter Description"
              value={addForm.Description}
              onChange={(e) =>
                setAddForm((prev) => ({ ...prev, Description: e.target.value }))
              }
              rows={3}
            ></textarea>
          </div>

          {askPasswordAdd && (
            <div className="mt-2">
              <div className="mb-3 w-lg-75 m-auto">
                <label className="form-label">
                  Confirm Password <span className="text-danger"> *</span>
                </label>
                <div className="pass-group">
                  <input
                    type={showPasswordAdd ? "text" : "password"}
                    className="pass-input form-control"
                    value={passwordAdd}
                    onChange={(e) => {
                      setPasswordAdd(e.target.value);
                      setErrorAdd("");
                    }}
                    onCopy={(e) => e.preventDefault()}
                    onPaste={(e) => e.preventDefault()}
                    onCut={(e) => e.preventDefault()}
                    placeholder="Enter Password"
                  />
                  <span
                    className={`ti toggle-password ${
                      showPasswordAdd ? "ti-eye" : "ti-eye-off"
                    }`}
                    onClick={() => setShowPasswordAdd(!showPasswordAdd)}
                  ></span>
                </div>
              </div>
              {errorAdd && (
                <div className="alert alert-danger" role="alert">
                  {errorAdd}
                </div>
              )}
              <button
                type="button"
                className="btn btn-primary btn-sm me-2"
                onClick={handleAuthAdd}
                disabled={addLoading || !passwordAdd}
              >
                {addLoading ? "Verifying..." : "Confirm"}
              </button>
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={() => {
                  setAskPasswordAdd(false);
                  setPasswordAdd("");
                  setErrorAdd("");
                }}
              >
                Cancel
              </button>
            </div>
          )}
        </Drawer>

        <Drawer
          title="Edit Area"
          placement="right"
          width={420}
          closable={false}
          open={editDrawerOpen}
          onClose={() => {
            setEditDrawerOpen(false);
            setEditForm({ Id: null, Name: "", Code: "", Description: "" });
            setAskPasswordEdit(false);
            setPasswordEdit("");
            setErrorEdit("");
          }}
          extra={
            <div>
              <button
                type="button"
                className="btn btn-sm btn-outline-success me-2"
                title="Update"
                onClick={handleEditSubmit}
                disabled={saving}
              >
                <i className="fa fa-check fs-4"></i>
              </button>
              <button
                type="button"
                className="btn-close text-reset"
                onClick={() => {
                  setEditDrawerOpen(false);
                  setEditForm({ Id: null, Name: "", Code: "", Description: "" });
                  setAskPasswordEdit(false);
                  setPasswordEdit("");
                  setErrorEdit("");
                }}
              ></button>
            </div>
          }
        >
          <div className="mb-3">
            <label className="form-label">
              Area Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="Name"
              placeholder="Enter Area Name"
              value={editForm.Name}
              onChange={(e) =>
                setEditForm((prev) => ({ ...prev, Name: e.target.value }))
              }
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Code</label>
            <input
              type="text"
              className="form-control"
              name="Code"
              placeholder="Enter Code"
              value={editForm.Code}
              onChange={(e) =>
                setEditForm((prev) => ({ ...prev, Code: e.target.value }))
              }
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Description</label>
            <textarea
              className="form-control"
              name="Description"
              placeholder="Enter Description"
              value={editForm.Description}
              onChange={(e) =>
                setEditForm((prev) => ({ ...prev, Description: e.target.value }))
              }
              rows={3}
            ></textarea>
          </div>

          {askPasswordEdit && (
            <div className="mt-2">
              <div className="mb-3 w-lg-75 m-auto">
                <label className="form-label">
                  Confirm Password <span className="text-danger"> *</span>
                </label>
                <div className="pass-group">
                  <input
                    type={showPasswordEdit ? "text" : "password"}
                    className="pass-input form-control"
                    value={passwordEdit}
                    onChange={(e) => {
                      setPasswordEdit(e.target.value);
                      setErrorEdit("");
                    }}
                    onCopy={(e) => e.preventDefault()}
                    onPaste={(e) => e.preventDefault()}
                    onCut={(e) => e.preventDefault()}
                    placeholder="Enter Password"
                  />
                  <span
                    className={`ti toggle-password ${
                      showPasswordEdit ? "ti-eye" : "ti-eye-off"
                    }`}
                    onClick={() => setShowPasswordEdit(!showPasswordEdit)}
                  ></span>
                </div>
              </div>
              {errorEdit && (
                <div className="alert alert-danger" role="alert">
                  {errorEdit}
                </div>
              )}
              <button
                type="button"
                className="btn btn-primary btn-sm me-2"
                onClick={handleAuthEdit}
                disabled={saving || !passwordEdit}
              >
                {saving ? "Verifying..." : "Confirm"}
              </button>
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={() => {
                  setAskPasswordEdit(false);
                  setPasswordEdit("");
                  setErrorEdit("");
                }}
              >
                Cancel
              </button>
            </div>
          )}
        </Drawer>

 
        <Modal
          title="Confirm Password"
          open={reauthVisible}
          onOk={handleDeleteConfirm}
          okText="Confirm"
          cancelText="Cancel"
          onCancel={() => {
            setReauthVisible(false);
            setPasswordDelete("");
            setPasswordErrorDelete("");
          }}
          confirmLoading={deleteLoading}
          width={380}
          okButtonProps={{  disabled: deleteLoading || !passwordDelete.trim() }}
        >
          <Spin spinning={deleteLoading}>
            <div className="mt-3">
              <label className="form-label">
                Password <span className="text-danger">*</span>
              </label>
              <Input.Password
                value={passwordDelete}
                onChange={(e) => {
                  setPasswordDelete(e.target.value);
                  setPasswordErrorDelete("");
                }}
                placeholder="Enter your password"
                onPressEnter={handleDeleteConfirm}
              />
              {passwordErrorDelete && (
                <div className="text-danger mt-2">{passwordErrorDelete}</div>
              )}
            </div>
          </Spin>
        </Modal>
      </div>
    </>
  );
};

export default Areas;